import { Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AsosPage } from "@/pages/Asos";
import { AtendimentoDetalhePage } from "@/pages/AtendimentoDetalhe";
import { AtendimentosPage } from "@/pages/Atendimentos";
import { ColaboradoresPage } from "@/pages/Colaboradores";
import { DocumentoRevisaoPage } from "@/pages/DocumentoRevisao";
import { DocumentosPage } from "@/pages/Documentos";
import { EmpresaDetalhePage } from "@/pages/EmpresaDetalhe";
import { EmpresasPage } from "@/pages/Empresas";
import { HomePage } from "@/pages/Home";
import { CatalogosPage } from "@/pages/Catalogos";
import { MedicosPage } from "@/pages/Medicos";
import { PendenciasPage } from "@/pages/Pendencias";

export default function App() {
  return (
    <ProtectedRoute>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/empresas" element={<EmpresasPage />} />
          <Route path="/empresas/:id" element={<EmpresaDetalhePage />} />
          <Route path="/colaboradores" element={<ColaboradoresPage />} />
          <Route path="/medicos" element={<MedicosPage />} />
          <Route path="/catalogos" element={<CatalogosPage />} />
          <Route path="/documentos" element={<DocumentosPage />} />
          <Route path="/documentos/:id/revisao" element={<DocumentoRevisaoPage />} />
          <Route path="/atendimentos" element={<AtendimentosPage />} />
          <Route path="/atendimentos/:id" element={<AtendimentoDetalhePage />} />
          <Route path="/asos" element={<AsosPage />} />
          <Route path="/pendencias" element={<PendenciasPage />} />
          <Route path="*" element={<div className="text-ink-muted">Página não encontrada.</div>} />
        </Route>
      </Routes>
    </ProtectedRoute>
  );
}
